import "./BorderedSection.scss";

export default {
  root: "im-bordered-section",
};
